import styled from 'styled-components';
import { DatePicker } from 'antd';
import type { Moment } from 'moment';
import momentGenerateConfig from 'rc-picker/lib/generate/moment';

const MyDatePicker = DatePicker.generatePicker<Moment>(momentGenerateConfig);
const { RangePicker } = MyDatePicker;

export const StyledDateRangePicker = styled(RangePicker)`
  width: 100%;
  height: 40px;
  font-size: 16px;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.palette.neutral[500]};
  &:hover,
  &:focus,
  &:focus-within {
    box-shadow: none !important;
    border-color: ${({ theme }) => theme.palette.secondary.main} !important;
  }
`;
